import React, { useState } from "react";
import propTypes from "prop-types";
import { Col } from "reactstrap";
import { Input, Popup } from "semantic-ui-react";

const InfoField = ({ item, model }) => (
  <Col xs={item.xs} sm={item.sm} md={item.md} lg={item.lg} xl={item.xl} className={'pb-2'} hidden={model[item.id].hidden}>
    <span className="title-field">
      {item.label}
    </span>
    <p className="value-field">{model[item.id].value}</p>
  </Col>
);

const InputField = ({ item, model, onChange }) => {
  const [showPass, setShowPass] = useState(false);

  const inputType = model[item.id].type === 'password' && showPass ? 'text' : model[item.id].type;

  return (
    <Col xs={item.xs} sm={item.sm} md={item.md} lg={item.lg} xl={item.xl} className={'pb-2'} hidden={model[item.id].hidden}>
      <span className="title-field">
        {item.label} {model[item.id].required && <span className="fiel-required">*</span>}
        {item.iconHelp && (
          <Popup
            trigger={<i className={item.iconHelp} />}
            content={item.condiciones}
            position="top right"
            size="mini"
            wide
            // inverted
          />
        )}
      </span>
      <div id="is-relative">
        <Input
          type={inputType || 'text'}
          value={model[item.id].value || ""}
          onChange={(e, data) => onChange(item.id, data.value)}
          fluid
          size="small"
          error={!model[item.id].valid || false}
          className="custom-input"

        />
        {model[item.id].type === 'password' && (
          <span id="icon-eye" onClick={() => setShowPass(!showPass)}>
            <i className={showPass ? "fas fa-eye" : "fas fa-eye-slash"} />
          </span>
        )}
      </div>
      {!model[item.id].valid && (
        <div className="error-message">
          <ul>
            {model[item.id].error.split(", ").map((err, index) => (
              <li key={index}>{err}</li>
            ))}
          </ul>
        </div>
      )}
    </Col>
  );
};


function FormCreator({ form, model, onChange }) {
  const renderField = (item, key) => {
    if (!item.id) {
      return (
        <Col key={key} xs={item.colm} sm={item.colm} md={item.colm} lg={item.colm} className={item.class}>
          {item.type === "header" && <span>{item.label}</span>}
        </Col>
      );
    }

    if (!model[item.id]) {
      console.warn(`🚀 ~ El campo con id "${item.id}" no está definido en el modelo.`);
      return null;
    }

    switch (item.type) {
      case "info":
        return <InfoField key={key} item={item} model={model} />;
      case "input":
        return <InputField key={key} item={item} model={model} onChange={onChange} />;
      default:
        return null;
    }
  };

  return <>{form.map((item, key) => renderField(item, `field-${key}`))}</>;
}

FormCreator.propTypes = {
  form: propTypes.array,
  model: propTypes.object,
};

FormCreator.defaultProps = {
  form_component: [],
  model: {},
};

export default React.memo(FormCreator);
